import React, { Component } from "react";
import ReactPaginate from 'react-paginate';

import {
    Form, FormGroup, Label,
    Input, Row, Col, Spinner
} from 'reactstrap';


import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BoxConfiguration from "../BoxCustomer/BoxConfiguration";
import OAuthService from '../Auth/OAuthService';


class BoxConfigurationPagination extends Component {
    state = {
        box_configurations: [],
        page_count: 0,
        page_size: 50,
        page: 0,
        tooltipOpen: false,
        popoverOpen: false,
        setTooltipOpen: false,
        loading: true
    }

    constructor(props){
        super(props);


        this.PAGE_SIZE_KEY = this.props.page_size_key;
        let page_size = localStorage.getItem(this.PAGE_SIZE_KEY) || 50;
        this.state.page_size = page_size;
        this.os = this.props.os || new OAuthService();
        this.getList(1);
    }

    boxConfigurationRows = () => {
        let boxConfigurationRows = this.state.box_configurations.map( key => {
            return <BoxConfiguration key={"boxConfigPg" + key.id} box_configuration={key} os={this.os}></BoxConfiguration>
        })
        return boxConfigurationRows;
    }

    getList = async (new_page) => {
        this.setState({ loading: true });
        let token = JSON.parse(localStorage.getItem("token"));
        this.os.getBoxObjects(token, "/api/v4/box_configurations", new_page, this.state.page_size).then((result) => {
            const configurations = result["box_configurations"];
            this.setState({
                box_configurations: configurations,
                page_count: result["meta"]['page_count'],
                page: new_page - 1,
                loading: false
            });
            // Notify parent of loaded configurations for batch modal
            if (this.props.onConfigurationsLoaded) {
                this.props.onConfigurationsLoaded(configurations);
            }
        }).catch((error) => {
            console.log('error', error);
            this.setState({
                box_configurations: [],
                loading: false
            })
        })

    }

    handlePageClick = (data) => {
        //console.log(data);
        this.getList(data.selected + 1);
    }

    handleChange = (e) => {
        localStorage.setItem(this.PAGE_SIZE_KEY, e.target.value);
        this.setState({
            page_size: e.target.value
        }, () => {
            this.getList(1);
        })
    }

    getIndex = (index) => {
        if(this.state.page == 0){
            return (index + 1);
        }else{
            return (this.state.page*this.state.page_size) + (index + 1);
        }
    }

    toggleTooltip = () => {
        this.setState({tooltipOpen: !this.state.tooltipOpen})
        return this.state.toggleTooltip
    }

    togglePopover = () => {
        this.setState({popoverOpen: !this.state.popoverOpen})
        return this.state.togglePopover
    }


    render() {
        return (
            <div>
                <ToastContainer
                    position="bottom-center"
                    autoClose={5000}
                    hideProgressBar
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss={false}
                    draggable={false}
                    pauseOnHover={false}
                />
                {this.state.loading && (
                    <div className="text-center py-5 mt-4">
                        <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
                        <div className="mt-2 text-muted">Loading Box Job Templates...</div>
                    </div>
                )}
                {!this.state.loading && this.state.box_configurations.length > 0 &&
                    <div key="boxConfigPgWrapper">
                        <div key="boxConfigPgHeader">
                            <hr style={{border: '2px solid rgba(0,0,0,.1)'}}/>
                            <h4>Box Job Templates</h4>
                            <Row className="my-2">
                                <Col className="col" md={2}>Name</Col>
                                <Col className="col" md={5}>Enclosure Product</Col>
                                <Col className="col" md={2}>Created</Col>
                                <Col className="col" md={1}></Col>
                            </Row>
                            {this.boxConfigurationRows()}
                        </div>
                        <div className="d-flex justify-content-between" key="boxConfigPgFooter">
                            { this.state.page_count > 1 && (
                                <div>
                                    <div style={{padding: '4px 0px'}}>
                                        <Form>
                                            <FormGroup className="form-inline form-short">
                                                <Label className="mr-1">Shows: </Label>
                                                <Input type="select" name="select" id="exampleSelect" onChange={this.handleChange} value={this.state.page_size}>
                                                    <option>10</option>
                                                    <option>20</option>
                                                    <option>50</option>
                                                    <option>100</option>
                                                </Input>
                                            </FormGroup>
                                        </Form>
                                    </div>
                                    <ReactPaginate
                                        previousLabel={'Previous'}
                                        nextLabel={'Next'}
                                        breakLabel={'...'}
                                        breakClassName={'break-me'}
                                        pageCount={this.state.page_count}
                                        marginPagesDisplayed={1}
                                        pageRangeDisplayed={5}
                                        onPageChange={this.handlePageClick}
                                        containerClassName={'pagination'}
                                        activeClassName={'active'}
                                        forcePage={this.state.page}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                }
                {!this.state.loading && this.state.box_configurations.length === 0 && (
                    <div className="text-center py-4">
                        <hr style={{border: '2px solid rgba(0,0,0,.1)'}}/>
                        <h4>Box Job Templates</h4>
                        <p className="text-muted">No Box Job Templates found. Click "+ New Box Job Template" to create one.</p>
                    </div>
                )}
            </div>
        )
    }

}
export default BoxConfigurationPagination;